import React from 'react';
import { motion } from 'framer-motion';
type PageHeroProps = {
  title: string;
  eyebrow?: string;
  subtitle?: string;
  note?: string;
  image: string;
  icon?: React.ReactNode;
};
export function PageHero({
  title,
  eyebrow,
  subtitle,
  note,
  image,
  icon
}: PageHeroProps) {
  return <section className="relative w-full overflow-hidden" data-id="element-91" data-mp="2391pittuk5u">
      <img src={image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" data-id="element-92" data-mp="23r6x4ygw8pw" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black" data-id="element-93" data-mp="urwrnrpitxpq" />
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1]
    }} className="relative mx-auto flex w-full max-w-3xl flex-col items-center px-5 py-28 text-center sm:px-8 sm:py-32" data-id="element-94" data-mp="g3jsymz1u0rj">
        {icon && <span className="mb-8 flex h-14 w-14 items-center justify-center rounded-full border border-lotus-500/40 text-lotus-500" data-id="element-95" data-mp="1dj7iy9z5sci5">
            {icon}
          </span>}
        {eyebrow && <p className="text-[11px] font-medium uppercase tracking-[0.4em] text-lotus-500" data-id="element-96" data-mp="2xjr1g22ndkyq">
            {eyebrow}
          </p>}
        <h1 className="text-shadow-soft mt-5 font-display text-5xl font-light tracking-wide text-white sm:text-6xl" data-id="element-97" data-mp="3c9oky4pmtmhl">
          {title}
        </h1>
        <div className="rule-gold mt-7 w-24" data-id="element-98" data-mp="3l8jtvok29aol" />
        {subtitle && <p className="mt-7 text-lg font-light leading-relaxed text-neutral-300" data-id="element-99" data-mp="3lawgif0rk97z">{subtitle}</p>}
        {note && <p className="mt-4 text-[15px] font-light leading-relaxed text-neutral-500" data-id="element-100" data-mp="3v6prhtyu3unn">{note}</p>}
      </motion.div>
    </section>;
}